import { QueryClient } from '@tanstack/react-query'
import { statisticsQueryKeys } from 'src/queries/queries.constants'
import { StatisticsKeys } from 'src/queries/statistics/statistics.queries.constants'

const CAN_ISSUE_VIRTUAL_CARDS_STATISTICS_KEYS = [
  StatisticsKeys.CreditCardsCanIssueVirtualCardsCount,
  StatisticsKeys.CreditCardsActiveCanIssueVirtualCardsCount,
]

/**
 * Refresh the can-issue-virtual-cards stats after a credit-card create/verify.
 * The user just changed their can-issue state, so let the default active
 * refetch reflect it immediately rather than folding into a possibly
 * pre-mutation in-flight fetch. A single user action fires once — no burst to
 * rate-limit, unlike the CREDIT_CARD pusher path.
 */
export const invalidateCanIssueVirtualCardsStatistics = (
  queryClient: QueryClient,
): void => {
  CAN_ISSUE_VIRTUAL_CARDS_STATISTICS_KEYS.forEach((statisticKey) => {
    queryClient.invalidateQueries({
      queryKey: statisticsQueryKeys.list([statisticKey]),
    })
  })
}
